export enum ETripTaskType {
  loading = 'loading',
  loading_wh = 'loading_wh',
  unloading = 'unloading',
  unloading_wh = 'unloading_wh',
  customs = 'customs',
  reloading_from = 'reloading_from',
  reloading_to = 'reloading_to',
  trailer_swap = 'trailer_swap',
  return_asset = 'return_asset',
}

export const TripTaskType: Record<ETripTaskType, string> = {
  [ETripTaskType.loading]: 'Loading',
  [ETripTaskType.loading_wh]: 'WH loading',
  [ETripTaskType.unloading]: 'Unloading',
  [ETripTaskType.unloading_wh]: 'WH unloading',
  [ETripTaskType.customs]: 'Customs',
  [ETripTaskType.reloading_from]: 'Reloading out',
  [ETripTaskType.reloading_to]: 'Reloading in',
  [ETripTaskType.trailer_swap]: 'Swap',
  [ETripTaskType.return_asset]: 'Return asset',
};
